module.exports = __webpack_public_path__ + "img/bg_duoduop_des_3.8de211ea.png";